var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper w-100" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 18 } },
        [
          _c("el-col", { attrs: { span: 9 } }, [
            _c("b", [_vm._v("Received At:")]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 9 } }, [
            _vm._v(_vm._s(_vm.getReceivedAt)),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.items, function (value, key) {
        return _c("el-row", { key: _vm.getKey(key), attrs: { gutter: 18 } }, [
          _vm.hasSubData(value)
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      staticClass: "font-weight-bold text-uppercase",
                      staticStyle: {
                        "padding-left": "9px",
                        "padding-right": "9px",
                      },
                    },
                    [_vm._v("\n        " + _vm._s(key) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _vm._l(value, function (subValue, subKey) {
                    return _c(
                      "div",
                      { key: _vm.getKey(subKey) },
                      [
                        _c("el-col", { attrs: { span: 9 } }, [
                          _c("b", [_vm._v(_vm._s(subKey))]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 9 } }, [
                          _vm._v(_vm._s(subValue || "---")),
                        ]),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            : _c(
                "div",
                [
                  _c("el-col", { attrs: { span: 9 } }, [
                    _c("b", [_vm._v(_vm._s(key))]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 9 } }, [
                    _vm._v(_vm._s(value || "---")),
                  ]),
                ],
                1
              ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }